import * as _ from "lodash";

export default function Throttle(timeout: number, leading?: boolean, trailing?: boolean): MethodDecorator {
    return function (target: object, key: string | symbol, descriptor: PropertyDescriptor | undefined) {
        if (descriptor === undefined) {
            descriptor = Object.getOwnPropertyDescriptor(target, key);
        }
        if (descriptor === undefined) {
            throw new Error(`target has no descriptor for key "${String(key)}"`)
        }
        const originalMethod = descriptor.value;

        const throttled = _.throttle(originalMethod, timeout, { leading, trailing });
        descriptor.value = throttled;
    }
}